import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import store from '@/store'
import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

// 路由与导航动态绑定

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const whitePath = ['/login', '/dashboard', '/']
watch(route, (to: any, from: any) => {
  if (whitePath.indexOf(to.path) === -1) {
    let obj = {
      menuName: to.name,
      menuUrl: to.path
    }

    store.commit("ADD_TABS", obj)
  }

}, { deep: true, immediate: true })
// onMounted(() => {
//   getIp()
// })
// const getIp = () => {
 
//   sessionStorage.setItem('ip', returnCitySN['cip'] || '0.0.0.0')
//   sessionStorage.setItem('city', returnCitySN['cname'] || '未知')
// }

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})